
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/offers",
      function () {
        return require("private-next-pages/[locale]/offers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/offers"])
      });
    }
  